export {default as chord} from "./src/chord";
export {default as ribbon} from "./src/ribbon";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-chord/index.js
// module id = 234
// module chunks = 0 1 2 3 4